import { useLocalSearchParams } from 'expo-router';

import { useViewEvents } from '../../events/hooks/useViewEvents';
import CalendlySession from './CalendlySession';

const CancelSession = () => {
    const { trackViewOnce } = useViewEvents();

    const { cancelUrl, doneRoute } = useLocalSearchParams<{
        cancelUrl?: string;
        doneRoute?: string;
    }>();

    trackViewOnce('GuidanceSessions/CancelSession');

    return (
        <CalendlySession
            headerText="Cancel now, book again soon"
            calendlyUrl={cancelUrl}
            doneRoute={doneRoute}
        />
    );
};

export default CancelSession;
